import { useState } from "react"
import Row from "../row";
import Arrow from "./arrow";

export default function ContentDropdown({ title = '', right = <></>, children, isOpen = false, toggleable = true }) {
    const [ toggled, setToggled ] = useState(isOpen);

    return (
        <div className="reusable-dropdown">
            <div className="resusable-dropdown__head">
                <Row gap="20px" alignItems="center" justifyContent="space-between">
                    <p>{ title }</p>
                    <Row gap="20px" alignItems="center">
                        { right }
                        { toggleable && <div style={{
                            width: '50px',
                            height: '50px',
                            cursor: 'pointer'
                        }} onClick={() => setToggled(!toggled)}>
                            <Arrow angle={toggled ? '180deg' : ''}/>
                        </div> }
                    </Row>
                </Row>
            </div>

            { toggled && <div className="reusable-dropdown__content">
                { children }
            </div> }
        </div>
    )
}